import { createFileRoute, redirect } from '@tanstack/react-router';
import { APP_ROUTES } from '@/const/routes';
import { companyApi } from '@/api/company.api';
import { companyKeys } from '@/queries/company.queries';

export const Route = createFileRoute('/app/')({
  beforeLoad: async ({ context }) => {
    const companies = await context.queryClient.ensureQueryData({
      queryKey: companyKeys.list(),
      queryFn: companyApi.list,
    });
    const hasRealCompany = companies.some((c) => !c.isDemo);
    if (hasRealCompany) {
      throw redirect({ to: APP_ROUTES.app.analysis });
    }
    throw redirect({ to: APP_ROUTES.app.onboarding, search: { step: 0 } });
  },
});
